'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LazyLoad = require('./src/LazyLoad');

var _LazyLoad2 = _interopRequireDefault(_LazyLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _LazyLoad2['default'];